var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('date-picker',{attrs:{"min":_vm.minDate,"max":_vm.maxDate,"lang":_vm.$i18n.locale},model:{value:(_vm.valueDate),callback:function ($$v) {_vm.valueDate=$$v},expression:"valueDate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }